import React from "react";
export default function SVGBlueprint() {
  return (
    <svg viewBox="0 0 512 512">
      <g fill="#000000">
        <g fill="#000000">
          <path
            fill="#000000"
            d="M411.151,0c-33.227,0-61.46,21.729-71.275,51.718L49.128,51.749c-12.851,0.002-23.27,10.42-23.27,23.273v413.705
       c0,12.853,10.42,23.273,23.273,23.273h362.02c41.349,0,74.991-33.64,74.991-74.989V74.989C486.142,33.64,452.5,0,411.151,0z
        M72.402,465.453V98.293l263.758-0.029v56.903H152.572c-12.853,0-23.273,10.42-23.273,23.273v206.853
       c0,12.853,10.42,23.273,23.273,23.273H336.16v28.444c0,10.065,2.006,19.667,5.618,28.444H72.402z M279.272,258.596v-56.882h56.879
       v56.882H279.272z M336.151,305.141v56.88h-56.879v-56.88H336.151z M175.845,258.596v-56.882h56.882v56.882H175.845z
        M232.727,305.141v56.88h-56.882v-56.88H232.727z M411.151,465.455c-15.684,0-28.445-12.76-28.445-28.444
       c0-15.686,12.761-28.447,28.445-28.447c15.684,0,28.445,12.761,28.445,28.447C439.596,452.695,426.835,465.455,411.151,465.455z
        M439.596,367.638c-8.778-3.613-18.381-5.62-28.445-5.62c-10.065,0-19.667,2.008-28.445,5.62V74.989
       c0-15.684,12.761-28.444,28.445-28.444c15.684,0,28.445,12.76,28.445,28.444V367.638z"
          />
        </g>
      </g>
    </svg>
  );
}
